import styled from "styled-components";
import Variables from "../../../../assets/styleVariables";

export const Container = styled.div`
  display: ${props => (props.show ? "flex" : "none")};
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999999;
  overflow-y: auto;
  max-height: 100vh;
  .overlay {
    background-color: rgba(255, 255, 255, 0.5);
    position: fixed;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
  }
`;
export const MoreMenuContainer = styled.div`
  position: relative;
  z-index: 999999;
  min-width: 473px;
  //min-height: 214px;
  -webkit-box-shadow: 0 2px 14px 0 #cccccc;
  -moz-box-shadow: 0 2px 14px 0 #cccccc;
  box-shadow: 0 2px 14px 0 #cccccc;
  background-color: ${Variables.colors.complementary};
  //max-height: 90vh;
  //min-height: 206px;

  .top-section {
    height: 154px;
    border-bottom: 1px solid ${Variables.colors.complementary_400};
    display: flex;
    width: 100%;
    flex-direction: column;
    align-items: center;
    padding: 8px;
    .top-loading-container {
      & > div {
        height: 80px;
      }
    }
    .title {
      font-size: ${Variables.font_sizes.x2_medium};
      color: ${Variables.colors.complementary_800};
      padding: 18px 0 8px;
    }
    .note {
      font-size: ${Variables.font_sizes.small};
      color: ${Variables.colors.complementary_600};
    }
  }
  .bottom-section {
    max-height: calc(90vh - 154px);
    overflow-y: auto;
    height: ${props => (props.count ? props.count * 52 + "px" : "auto")};
  }
`;

const TYPES = {
  warning: Variables.colors.yellow_400,
  primary: Variables.colors.primary_400,
  error: Variables.colors.red_600,
  second: Variables.colors.complementary_700
};
export const Item = styled.div`
  width: 100%;
  //height: 40px;
  visibility: ${props => (props.show ? "visible" : "hidden")};
  display: flex;
  align-items: center;
  cursor: pointer;
  height: 52px;
  padding: 0 16px;
  .item-text {
    font-size: ${Variables.font_sizes.medium};
    color: ${props =>
      props.isLoading
        ? Variables.colors.complementary_700
        : Variables.colors.complementary_800};
    font-weight: ${props =>
      props.isLoading
        ? Variables.font_weight.medium
        : Variables.font_weight.regular};
    margin-right: 8px;
  }
  .item-icon {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 10px;
    &:before {
      margin: 0;
      font-size: 12.5px;
      color: ${props => (props.type ? TYPES[props.type] : TYPES["second"])};
    }
  }
`;
